module.exports = __webpack_public_path__ + "hM0gekQOUVruWAbHF/white-logo.svg";